import { showCookiesWarningBlock } from './parts/popups';
import { initModals } from './parts/modals';
import { updateCf7AcceptanceTimeOnPolicyChange } from './parts/cf7';

initModals();

jQuery(document).ready(function () {
    showCookiesWarningBlock();
    updateCf7AcceptanceTimeOnPolicyChange();
});
